import { Tag } from 'antd';
import styled from 'styled-components';

export const TooltipItem = styled.span`
  font-size: 12px;
`;

export const TagItem = styled(Tag)`
  background-color: #f3f5f7;
  border-radius: 2px;
  cursor: pointer;
  display: flex;
  gap: 4px;
  align-items: center;
  border-radius: 6px;
`;
